import { OptionType } from '@evinced-private/ui-common';

import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import { extractLabelKey, isCoreLabel } from './helpers';
import { TestRowSharedType } from './types';

export const extractAvailableLabelTypes = <T extends TestRowSharedType>(
	testRows: T[],
	allLabels: ConfigurationLabel[]
): OptionType[] => {
	if (allLabels?.length === 0 || testRows?.length === 0) {
		return allLabels.map((label) => ({
			value: label.label,
			label: label.displayName || label.label
		}));
	}

	return allLabels
		.filter((label) => {
			const labelKey = label.label.toLowerCase();
			const isCore = isCoreLabel(label.label);

			if (isCore) {
				const rowsWithLabel = testRows.filter((row) => {
					const keys = (row?.labels ?? []).map((label: string) =>
						extractLabelKey(label).toLowerCase()
					);
					return keys.includes(labelKey);
				});
				return rowsWithLabel.length < testRows.length;
			}
			return true;
		})
		.map((label) => ({
			value: label.label,
			label: label.displayName || label.label
		}));
};
